module.exports = __webpack_public_path__ + "img/4.81551ce3.jpg";